/**
 * Поставить фокус в поле ввода диалога внутри рельса или листа Karl (FE-586).
 *
 * Поле приносит `KarlDialogue`, а не рельс, поэтому оно ищется в разметке.
 * Пока Karl отвечает, поле заблокировано и фокуса не принимает — тогда к нему
 * хотя бы прокручивается колонка: человек видит, где идёт разговор.
 *
 * **Подстановка начала сообщения** (FE-587, «Suche anpassen»): `prefill` встаёт
 * только в пустое поле, курсор — в конец. Черновик, который человек уже набрал,
 * не перетирается никогда: его слова важнее нашей заготовки.
 */
export function focusKarlInput(container: HTMLElement | null, prefill?: string): void {
  if (container === null) return;
  const input = container.querySelector('textarea');
  if (input === null) {
    container.scrollIntoView({ block: 'nearest' });
    return;
  }

  if (prefill !== undefined && prefill !== '' && input.value.trim() === '') {
    setControlledValue(input, prefill);
  }

  if (input.disabled) {
    container.scrollIntoView({ block: 'nearest' });
    return;
  }
  input.focus();
  const end = input.value.length;
  input.setSelectionRange(end, end);
}

/**
 * Записать значение в управляемое React поле так, как это сделал бы ввод с
 * клавиатуры.
 *
 * Поле принадлежит диалогу (`ChatComposer`), а его состояние — черновику
 * (`useChatDraft`), который живёт в другой фиче и об оболочке не знает. Прямое
 * присваивание `input.value` React не заметил бы: он сравнивает значение со
 * своей копией и отслеживает присваивания через свойство экземпляра. Поэтому
 * значение пишется сеттером прототипа, а затем поднимается обычное событие
 * `input` — React получает его как ввод и вызывает `onChange` поля, то есть
 * черновик обновляется своим штатным путём, вместе с зеркалом в
 * `sessionStorage`.
 */
function setControlledValue(input: HTMLTextAreaElement, value: string): void {
  const descriptor = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value');
  if (descriptor?.set === undefined) return;
  descriptor.set.call(input, value);
  input.dispatchEvent(new Event('input', { bubbles: true }));
}
